//import { Component, EventEmitter, OnInit, Output,  NgZone } from '@angular/core';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';
import { Router, RouteConfigLoadStart, ResolveStart, RouteConfigLoadEnd, ResolveEnd, NavigationEnd } from '@angular/router';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { debounceTime, startWith } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { Roles } from '@stockcare-helpers/roles';
import { AboutComponent } from '@stockcare-views/about/about.component';
import { interval, Subject, Subscription } from 'rxjs';
import { isNull } from 'lodash';
import { ConnectionService } from '@stockcare-services/connection-service/connection.service';
import { HeaderService } from '@stockcare-services/header-service/header.service';
import { MenuItem } from './menu-item';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { QueueService } from '@stockcare-services/queue-service/queue.service';
import { MessagesDetailDialogComponent } from '@stockcare-views/messages/messages-detail-dialog/messages-detail-dialog.component';
import { MessagesService } from '@stockcare-services/messages-service/messages.service';
import { UrlWithStringQuery } from 'url';

interface TreeNode {
  name: string;
  children?: TreeNode[];
  display: string;
  route: string;
  icon: string;
}

interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
}


@Component({
  standalone: false,
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  Type: string = '';
  opened: boolean = false;
  activeRoute: any;
  isTheaterDevice: boolean;
  isEmergencyCupboardDevice: boolean;
  hideBackground: boolean;
  enableMaterialTransfer: boolean;
  showInitials: false;
  deviceType: string = '';
  stockLocationHasPermissionToTransferStock: boolean = true;
  enablePackManagement: boolean = false;
  enableTraining: boolean = false;
  shouldAddDefaultProcedureItems: boolean;
  isBackOfficeDevice: boolean;
  isTisScoringDevice: boolean;
  enableMyVoiceSurveys: boolean = false;
  enableStockTransferApprovals: boolean = false;
  enableStockCounting: boolean = false;
  enableTisScoring: boolean = false;
  useNewMenuStructure: boolean = false;
  @Output() itemClicked = new EventEmitter<string>();
  dropDownMenu: MenuItem[] = [];
  menu: MenuItem[] = [];
  treeFlattener: MatTreeFlattener<
  TreeNode,
  {
    expandable: boolean;
    name: string;
    level: number;
    display: string;
    route: string;
    icon: string;
  }
>;
  dataSource: MatTreeFlatDataSource<TreeNode, FlatNode>;
  treeControl: FlatTreeControl<FlatNode>;
  isTheatreBackOfficeDevice: boolean;
  isOriginalTheatreDevice: boolean;
  newMessage: boolean = false;
  messaging: boolean = false;
  messageInterval: number = 0;
  messageCheckInterval: Subscription;
  messageCount: number = 0;
  messageOpen: boolean = false;


  constructor(
    private authService: AuthenticationService,
    private headerService: HeaderService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private modalService: MatDialog,
    private settingService: SettingsService,
    private deviceService: DeviceService,
    private connectionService: ConnectionService,
    private queueService: QueueService,
    private messageService: MessagesService
  ) {
    
    this.isTheaterDevice = deviceService.isTheaterDevice();
    this.isOriginalTheatreDevice = deviceService.isOriginalTheatreDevice();
    this.isEmergencyCupboardDevice = deviceService.isEmergencyCupboardDevice();
    this.isBackOfficeDevice = deviceService.isBackOfficeDevice();
    this.isTisScoringDevice = deviceService.isTisScoringDevice();
    this.isTheatreBackOfficeDevice = deviceService.isTheatreBackOfficeDevice();
    if (deviceService.isWhiteboardDevice()) {
      this.isWhiteboardDevice = true;
    }
    deviceService.localDeviceUpdated.subscribe(() => {
      this.isTheaterDevice = deviceService.isTheaterDevice();
      this.isEmergencyCupboardDevice = deviceService.isEmergencyCupboardDevice();
    });

        
  }
  username: string;
  initials: string = '';
  isLoggedIn: boolean;
  heading: string = '';
  moduleLoading: boolean;
  showIcon = true;
  icon: string = 'hamburger';
  isConnected: boolean = true;
  stockLocation: string;
  subscriptions = new Subscription();
  isWhiteboardDevice: boolean;
  queryParams: any;
  overrideAction: boolean;
  physicalLocationTheatreRoomName: string;
  theatreTimer: number;
  recoveryTimer: number;
  private menuClicked = new Subject<string>();
  private isCheckingMessages = false;
  
  ngOnInit() {
    this.getUsernameFromToken();
    this.moduleIsLoading();
    this.getInitials();
    this.buildDeviceType();
    this.buildStockLocationHasPermissionToTransferStock();

    this.shouldHideBackground(this.router.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.shouldHideBackground(event.url);
      }
    });
    this.headerService.header.subscribe((newHeader) => {
      if (!isNull(newHeader)) {
        this.heading = newHeader.heading;
        this.showIcon = newHeader.showIcon;
        this.icon = newHeader.icon || this.icon;
        this.queryParams = newHeader.queryParams;
        this.overrideAction = newHeader.overrideAction;
      }
    });
    this.headerService.theatreTimer.subscribe((result) => {
      this.theatreTimer = result;
    });
    this.headerService.recoveryTimer.subscribe((result) => {
      this.recoveryTimer = result;
    });
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      this.headerService.isOnline = isConnected;
      if (this.isConnected) {
        this.queueService.processTheatreQueueWhenDeviceComesOnline();
      }
      //this.ngZone.run(() =>{
        this.isConnected = isConnected;
      //});
    });
    this.getStockLocationName();
    this.subscribeToDeviceChanges();

    const menuClickedDebounced = this.menuClicked.pipe(debounceTime(200));
    menuClickedDebounced.subscribe(() => {
      if (this.overrideAction) {
        this.headerService.back.next();
        return;
      }
      if (this.icon === 'arrow-back') {
        this.router.navigate([this.headerService.navUrl], this.queryParams);
      } else {
        this.toggleSideBar(true);
      }
    });

    this.enableMaterialTransfer = this.settingService.getBooleanSetting(Settings.ENABLE_ACTION_CENTER);
    this.enablePackManagement = this.settingService.getBooleanSetting(Settings.ENABLE_PACK_MANAGEMENT);
    this.enableTraining = this.settingService.getBooleanSetting(Settings.ENABLE_REQUEST_TRAINING);
    this.shouldAddDefaultProcedureItems = this.settingService.getBooleanSetting(Settings.ENABLE_DEFAULT_PROCEDURE_MATERIALS);
    this.enableMyVoiceSurveys = this.settingService.getBooleanSetting(Settings.ENABLE_MY_VOICE_SURVEYS);
    this.enableStockTransferApprovals = this.settingService.getBooleanSetting(Settings.ENABLE_STOCK_TRANSFER_APPROVALS);
    this.enableStockCounting = this.settingService.getBooleanSetting(Settings.ENABLE_STOCK_COUNTING);
    this.enableTisScoring = this.settingService.getBooleanSetting(Settings.ENABLE_TIS_SCORING);
    this.useNewMenuStructure = this.settingService.getBooleanSetting(Settings.USE_NEW_MENU_STRUCTURE);
    this.messaging = this.settingService.getBooleanSetting(Settings.MESSAGING);
    this.messageInterval = this.settingService.getSetting(Settings.MESSAGING_INTERVAL).value / 60;

    this.initializeTree();
    this.buildRoutes();

    if (this.messaging) {
      this.checkForNewMessages();
      this.setupMessageChecking();
    }

  }

  buildStockLocationHasPermissionToTransferStock() {

    var excludedStockLocation = this.settingService.getSettingObjectParsed(Settings.WARDS_TO_EXCLUDE_FROM_STOCK_TRANSFER);

    var excludedStockLocationIds = excludedStockLocation.map((x) => +x.value);

    var stockLocationId = this.deviceService.getStockLocationId();

    if (excludedStockLocationIds.includes(stockLocationId)) {
      this.stockLocationHasPermissionToTransferStock = false;
    }
  }

  buildDeviceType() {
    var device = JSON.parse(localStorage.getItem('device'));

    this.deviceType = this.deviceService.buildDeviceName(device);
  }

  shouldHideBackground(url: string): void {
    this.hideBackground = url && (url.includes('operating') || url.includes('action-center') || url.includes('whiteboard'));
  }

  ngAfterViewInit(): void {
    if (this.activeRoute) {
      this.updateHeader(this.activeRoute.display);
    }
  }

  subscribeToDeviceChanges() {
    this.subscriptions.add(
      this.deviceService.localDeviceUpdated.subscribe(() => {
        this.getStockLocationName();
        this.buildRoutes();
      })
    );
  }

  getStockLocationName() {
    const device = this.deviceService.getDeviceFromLocalStorage();
    this.stockLocation = device.stockLocationName;
    this.physicalLocationTheatreRoomName = device.physicalLocationTheatreRoomName;
  }

  onMenuClicked() {
    this.menuClicked.next();
  }

  ngOnDestroy(): void {
    // Make sure to unsubscribe when the component is destroyed
  if (this.messageCheckInterval) {
    this.messageCheckInterval.unsubscribe();
  }

    this.subscriptions.unsubscribe();
  }

  private moduleIsLoading() {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        this.moduleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.moduleLoading = false;
      }
    });
  }

  private getUsernameFromToken() {
    const token = localStorage.getItem('token');
    const decodedToken = this.authService.decodeToken(token);
    this.username = decodedToken.unique_name;
  }

  getInitials() {
    const names: string[] = this.username.replace('.', ' ').split(' ');
    for (const name of names) {
      this.initials += name[0];
    }
    this.initials = this.initials.substring(0, 2).toUpperCase();
  }

  toggleSideBar(value) {
    if (value) {
      this.opened = !this.opened;
    } else {
      this.headerService.backArrowClicked(true);
    }
  }

  updateHeader(heading: string) {
    this.headerService.updateHeader({
      heading,
      icon: 'hamburger',
      queryParams: null,
      showIcon: true,
      overrideAction: false,
    });
  }

  isActiveMenu(name: string): boolean {
    if (this.menu.find(x => x.roles).route === this.router.url) {
      this.activeRoute = this.menu.find(x => x.roles);
      return true;
    }
    return false;
  }

  isAuthorised(roles: string[]): boolean {
    return this.authenticationService.isInRole(roles);
  }

  showAbout() {
    this.modalService.open(AboutComponent, {
      width: '385px',
    });
  }

  signOut() {
    this.router.navigate(['app/signout']);
  }

  private transformer = (node: TreeNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
      display: node.display,
      route: node.route,
      icon: node.icon
    };
  };

  private initializeTree() {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      (node) => node.level,
      (node) => node.expandable,
      (node) => node.children
    );
    this.treeControl = new FlatTreeControl<FlatNode>(
      (node) => node.level,
      (node) => node.expandable
    );
  }

  hasChild(_: number, node: FlatNode) {
    return node.expandable;
  }

  buildTree() {
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    const data = [];

    this.menu.forEach((item: MenuItem) => {
      if ((item.roles.length === 0 || this.authenticationService.isInRole(item.roles)) && item.parent === '') {
        const children = this.buildTreeItemChildren(item);

        if (item.isParent) {
          if (children && children.length > 0) {
            data.push({
              name: item.name,
              display: item.display,
              route: item.route,
              children: children,
            });
          }
        } else {
          if((item.roles.length === 0 || this.authenticationService.isInRole(item.roles)) && item.active)
            data.push({
              name: item.name,
              display: item.display,
              route: item.route,
              children: [],
              icon: item.icon
            });
        }
      }
    });

    this.dataSource.data = data;

  }

  buildTreeItemChildren(parentItem: MenuItem) {
    const children: TreeNode[] = [];
    this.menu.forEach((item: MenuItem) => {
      if ((item.roles.length === 0 || this.authenticationService.isInRole(item.roles)) && item.parent === parentItem.name && item.active) {
        children.push({
          name: item.name,
          display: item.display,
          route: item.route,
          icon: item.icon
        });
      }
    });

    return children;
  }

  buildRoutes() {
    this.menu = [];
    
    if(this.useNewMenuStructure)
      {
        this.buildNewMenu();
      }
      else{
        this.buildOldMenu();
      }
    
    this.buildTree();
  }

  getBarStyling(): string {
    return this.router.url.indexOf('/accounts/') !== -1 || this.router.url.indexOf('home') !== -1 ? 'toolbar-row-2' : 'toolbar-row-2-sm';
  }

  getLogoStyling(): string {
    return this.router.url.indexOf('/accounts/') !== -1 || this.router.url.indexOf('home') !== -1 ? 'logo' : 'logo-sm';
  }

  getBackgroundStyling(): string {
    return this.router.url.indexOf('/accounts/') !== -1 || this.router.url.indexOf('home') !== -1
      ? 'background-image transparent-headers'
      : '';
  }

  isInRole(roles: string[]): boolean {
    return this.authenticationService.isInRole(roles);
  }

  navigate(treeNode: TreeNode) {
    if (treeNode.name === 'logOut') {
      this.signOut();
      return;
    }

    if (treeNode.name === 'showAbout') {
      this.showAbout();
      return;
    }

    const item = this.getMenuItem(treeNode.route);

    this.opened = false;
    this.updateHeader(item.name);
    this.itemClicked.emit(item.display);
    this.router.navigate([item.route, { type: item.name }]);

  }

  toggleMenuItem(item: MenuItem) {
    item.showChilden = !item.showChilden;
  }
  
  private getMenuItem(name: string): MenuItem {
    return this.menu.find((x) => x.route === name);
  }

  private buildOldMenu(){
    var rolesPatients = [Roles.superAdministrator, Roles.systemAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesDischargedPatients = [Roles.superAdministrator, Roles.systemAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesMovementPatient = [Roles.superAdministrator, Roles.systemAdministrator, Roles.hospitalAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesBaskets = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator, Roles.creditApprover];
    var rolesWhiteboard = [Roles.superAdministrator, Roles.systemAdministrator];
    var rolesEmergencyCub = [Roles.superAdministrator, Roles.systemAdministrator, Roles.emergencyCupboardStockIssuer];
    var rolesRequestTraining = [Roles.systemAdministrator, Roles.superAdministrator, Roles.stockIssuer, Roles.creditRequester, Roles.theatre];
    var rolesTrainingRequests = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesStockTransfer = [Roles.superAdministrator, Roles.systemAdministrator, Roles.materialTransfer];
    var rolesStockTransferApproval = [Roles.superAdministrator, Roles.systemAdministrator, Roles.materialTransfer];
    var rolesDevices = [Roles.systemAdministrator, Roles.superAdministrator];
    var rolesUsers = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesContactManagement = [Roles.systemAdministrator, Roles.superAdministrator];
    var rolesPackManagement = [Roles.superAdministrator, Roles.systemAdministrator, Roles.pharmacy];
    var rolesReporting = [Roles.superAdministrator, Roles.systemAdministrator, Roles.reportViewer];
    var rolesTheatre = [Roles.superAdministrator, Roles.systemAdministrator, Roles.theatre];
    var rolesTheatreHistory = [Roles.superAdministrator, Roles.systemAdministrator, Roles.theatre];
    var rolesApprovals = [Roles.systemAdministrator, Roles.superAdministrator, Roles.creditApprover];
    var rolesTisScoring = [Roles.tisScoring, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesTisScoringCalculation = [Roles.superAdministrator];
    var rolesSettings = [Roles.superAdministrator];
    var rolesSurveys = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator, Roles.creditApprover];
    var rolesStockCounting = [Roles.systemAdministrator, Roles.superAdministrator,Roles.stockCountManager];
    var rolesPreAdmission = [Roles.systemAdministrator, Roles.superAdministrator,Roles.preAdmission];
    var rolesTheatreConfiguration = [Roles.systemAdministrator, Roles.superAdministrator];

    this.menu.push(
      new MenuItem(
        'app/patients',
        'Patients',
        'patients',
        rolesPatients,
        '',
        false,
        'user',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/patients/discharged/true',
        'Discharged Patients',
        'discharged-patients',
        rolesDischargedPatients,
        '',
        false,
        'discharged-patients',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre',
        'Theatre',
        'theatre',
        rolesTheatre,
        '',
        false,
        'theatre',
        (this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre/patient/history',
        'Theatre History',
        'theatre-patient-history',
        rolesTheatreHistory,
        '',
        false,
        'history-clock-button',
        (this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre-default-config',
        'Theatre Default Config',
        'theatre-default-config',
        rolesTheatreConfiguration,
        '',
        false,
        'config',
        this.isTheaterDevice && !this.isEmergencyCupboardDevice && this.shouldAddDefaultProcedureItems
      )
    );

    this.menu.push(
      new MenuItem(
        'app/patients/movement',
        'Patient Summary',
        'movement-patient',
        rolesMovementPatient,
        '',
        false,
        'patient-summary',
        !this.isTheatreBackOfficeDevice
      )
    );

    this.menu.push(
      new MenuItem(
      'app/approvals',
      'Credit Approvals',
      'approvals',
      rolesApprovals,
      '',
      false,
      'done',
      !this.isOriginalTheatreDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/baskets',
        'Baskets',
        'baskets',
        rolesBaskets,
        '',
        false,
        'basket',
        !this.isTheaterDevice && !this.isEmergencyCupboardDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/reporting',
        'Reporting',
        'reporting',
        rolesReporting,
        '',
        false,
        'reporting'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/request-training/new-request',
        'Request Training',
        'request-training',
        rolesRequestTraining,
        '',
        false,
        'training',
        this.enableTraining
      )
    );

    this.menu.push(
      new MenuItem(
        'app/request-training/requests',
        'Training Requests',
        'training-requests',
        rolesTrainingRequests,
        '',
        false,
        'list',
        this.enableTraining
      )
    );

    this.menu.push(
      new MenuItem(
        'app/emergency-cupboard',
        'Emergency Cupboard',
        'emergency-cupboard',
        rolesEmergencyCub,
        '',
        false,
        'emergency-cupboard',
        this.isEmergencyCupboardDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/pack-management/pack-list',
        'Pack Management',
        'pack-management',
        rolesPackManagement,
        '',
        false,
        'drawer',
        this.enablePackManagement
      )
    );

    
    this.menu.push(
      new MenuItem(
        'app/devices',
        'Devices',
        'devices',
        rolesDevices,
        '',
        false,
        'devices'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/users',
        'Users',
        'users',
        rolesUsers,
        '',
        false,
        'people'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/whiteboard',
        'Whiteboard',
        'whiteboard',
        rolesWhiteboard,
        '',
        false,
        'whiteboard',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/material-transfer',
        'Stock Transfer',
        'material-transfer',
        rolesStockTransfer,
        '',
        false,
        'calculator',
        (this.enableMaterialTransfer && this.stockLocationHasPermissionToTransferStock)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/material-transfer/approvals/list',
        'Stock Transfer Approval',
        'Stock Transfer Approval',
        rolesStockTransferApproval,
        '',
        false,
        'done',
        (this.enableMaterialTransfer && this.enableStockTransferApprovals)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/stock-counting',
        'Stock Counting',
        'StockCounting',
        rolesStockCounting,
        '',
        false,
        'stack',
        this.enableStockCounting
      )
    );

     //devider

    this.menu.push(
      new MenuItem(
        'app/settings',
        'Settings',
        'settings',
        rolesSettings,
        '',
        false,
        'settings'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/my-voice-surveys',
        'Surveys',
        'Surveys',
        rolesSurveys,
        '',
        false,
        'list',
        ((this.isBackOfficeDevice || this.isTheatreBackOfficeDevice) && this.enableMyVoiceSurveys)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/contact-management',
        'Contact Management',
        'contact-management',
        rolesContactManagement,
        '',
        false,
        'user-tie'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/pre-admission',
        'Pre Admission',
        'PreAdmission',
        rolesPreAdmission,
        '',
        false,
        'file-text2',
        (this.isBackOfficeDevice || this.isTheatreBackOfficeDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/tis-scoring',
        'Tis Scoring',
        'TisScoring',
        rolesTisScoring,
        '',
        false,
        'list',
        (this.isTisScoringDevice && this.enableTisScoring)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/tis-scoring-calculation',
        'Tis Scoring Calculation',
        'tis-scoring-calculation',
        rolesTisScoringCalculation,
        '',
        false,
        'list',
        (this.isTisScoringDevice && this.enableTisScoring)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/survey-escalation-management',
        'Survey Escalation Management',
        'SurveyEscalationManagement',
        rolesUsers,
        '',
        false,
        'list',
        ((this.isBackOfficeDevice || this.isTheatreBackOfficeDevice) && this.enableMyVoiceSurveys)
      )
    );

    this.menu.push(new MenuItem('showAbout', 'Show About', 'showAbout', [],'',
      false,
      'info'));

    this.menu.push(new MenuItem('logOut', 'Log Out', 'lognOut', [],'',
      false,
      'sign-out'));

  }

  private buildNewMenu(){
    var rolesPatients = [Roles.superAdministrator, Roles.systemAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesDischargedPatients = [Roles.superAdministrator, Roles.systemAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesMovementPatient = [Roles.superAdministrator, Roles.systemAdministrator, Roles.hospitalAdministrator, Roles.creditRequester, Roles.stockIssuer];
    var rolesBaskets = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator, Roles.creditApprover];
    var rolesWhiteboard = [Roles.superAdministrator, Roles.systemAdministrator];
    var rolesEmergencyCub = [Roles.superAdministrator, Roles.systemAdministrator, Roles.emergencyCupboardStockIssuer];
    var rolesRequestTraining = [Roles.systemAdministrator, Roles.superAdministrator, Roles.stockIssuer, Roles.creditRequester, Roles.theatre];
    var rolesTrainingRequests = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesStockTransfer = [Roles.superAdministrator, Roles.systemAdministrator, Roles.materialTransfer];
    var rolesStockTransferApproval = [Roles.superAdministrator, Roles.systemAdministrator, Roles.materialTransfer];
    var rolesDevices = [Roles.systemAdministrator, Roles.superAdministrator];
    var rolesUsers = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesContactManagement = [Roles.systemAdministrator, Roles.superAdministrator];
    var rolesPackManagement = [Roles.superAdministrator, Roles.systemAdministrator, Roles.pharmacy];
    var rolesReporting = [Roles.superAdministrator, Roles.systemAdministrator, Roles.reportViewer];
    var rolesTheatre = [Roles.superAdministrator, Roles.systemAdministrator, Roles.theatre];
    var rolesTheatreHistory = [Roles.superAdministrator, Roles.systemAdministrator, Roles.theatre];
    var rolesApprovals = [Roles.systemAdministrator, Roles.superAdministrator, Roles.creditApprover];
    var rolesTisScoring = [Roles.tisScoring, Roles.superAdministrator, Roles.hospitalAdministrator];
    var rolesTisScoringCalculation = [Roles.superAdministrator];
    var rolesSettings = [Roles.superAdministrator];
    var rolesSurveys = [Roles.systemAdministrator, Roles.superAdministrator, Roles.hospitalAdministrator, Roles.creditApprover];
    var rolesStockCounting = [Roles.systemAdministrator, Roles.superAdministrator,Roles.stockCountManager];
    var rolesPreAdmission = [Roles.systemAdministrator, Roles.superAdministrator,Roles.preAdmission];
    var rolesTheatreConfiguration = [Roles.systemAdministrator, Roles.superAdministrator];

    this.menu.push(
      new MenuItem(
        '',
        'Ward Billing',
        'Ward Billing',
        [
        ],
        '',
        true
      )
    );

    this.menu.push(
      new MenuItem(
        'app/patients',
        'Patients',
        'patients',
        rolesPatients,
        'Ward Billing',
        false,
        'user',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/patients/discharged/true',
        'Discharged Patients',
        'discharged-patients',
        rolesDischargedPatients,
        'Ward Billing',
        false,
        'discharged-patients',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/patients/movement',
        'Patient Summary',
        'movement-patient',
        rolesMovementPatient,
        'Ward Billing',
        false,
        'patient-summary',
        !this.isTheatreBackOfficeDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/baskets',
        'Baskets',
        'baskets',
        rolesBaskets,
        'Ward Billing',
        false,
        'basket',
        !this.isTheaterDevice && !this.isEmergencyCupboardDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/whiteboard',
        'Whiteboard',
        'whiteboard',
        rolesWhiteboard,
        'Ward Billing',
        false,
        'whiteboard',
        (!this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/emergency-cupboard',
        'Emergency Cupboard',
        'emergency-cupboard',
        rolesEmergencyCub,
        'Ward Billing',
        false,
        'emergency-cupboard',
        this.isEmergencyCupboardDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/tis-scoring',
        'Tis Scoring',
        'TisScoring',
        rolesTisScoring,
        'Ward Billing',
        false,
        'list',
        (this.isTisScoringDevice && this.enableTisScoring)
      )
    );


    this.menu.push(
      new MenuItem(
        '',
        'Training',
        'Training',
        [
         
        ],
        '',
        true
      )
    );

    this.menu.push(
      new MenuItem(
        'app/request-training/new-request',
        'New Request Training',
        'request-training',
        rolesRequestTraining,
        'Training',
        false,
        'training',
        this.enableTraining
      )
    );

    this.menu.push(
      new MenuItem(
        'app/request-training/requests',
        'Training Requests',
        'training-requests',
        rolesTrainingRequests,
        'Training',
        false,
        'list',
        this.enableTraining
      )
    );

    this.menu.push(
      new MenuItem(
        '',
        'Stock Transfers',
        'Stock Transfers',
        [
         
        ],
        '',
        true
      )
    );

    this.menu.push(
      new MenuItem(
        'app/material-transfer',
        'Stock Transfer',
        'material-transfer',
        rolesStockTransfer,
        'Stock Transfers',
        false,
        'calculator',
        (this.enableMaterialTransfer && this.stockLocationHasPermissionToTransferStock)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/material-transfer/approvals/list',
        'Stock Transfer Approval',
        'Stock Transfer Approval',
        rolesStockTransferApproval,
        'Stock Transfers',
        false,
        'done',
        (this.enableMaterialTransfer && this.enableStockTransferApprovals)
      )
    );

    this.menu.push(
      new MenuItem(
        '',
        'General Management',
        'General Management',
        [],
        '',
        true
      )
    );

    this.menu.push(
      new MenuItem(
        'app/devices',
        'Devices',
        'devices',
        rolesDevices,
        'General Management',
        false,
        'devices'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/users',
        'Users',
        'users',
        rolesUsers,
        'General Management',
        false,
        'people'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/settings',
        'Settings',
        'settings',
        rolesSettings,
        'General Management',
        false,
        'settings'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/contact-management',
        'Contact Management',
        'contact-management',
        rolesContactManagement,
        'General Management',
        false,
        'user-tie'
      )
    );

    this.menu.push(
      new MenuItem(
        'app/pack-management/pack-list',
        'Pack Management',
        'pack-management',
        rolesPackManagement,
        'General Management',
        false,
        'drawer',
        this.enablePackManagement
      )
    );

    this.menu.push(
      new MenuItem(
        'app/tis-scoring-calculation',
        'Tis Scoring Calculation',
        'tis-scoring-calculation',
        rolesTisScoringCalculation,
        'General Management',
        false,
        'list',
        (this.isTisScoringDevice && this.enableTisScoring)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/reporting',
        'Reporting',
        'reporting',
        rolesReporting,
        'General Management',
        false,
        'reporting'
      )
    );

    this.menu.push(
      new MenuItem(
        '',
        'Theatre',
        'Theatre',
        [
         
        ],
        '',
        true
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre',
        'Theatre',
        'theatre',
        rolesTheatre,
        'Theatre',
        false,
        'theatre',
        (this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre/patient/history',
        'Theatre History',
        'theatre-patient-history',
        rolesTheatreHistory,
        'Theatre',
        false,
        'history-clock-button',
        (this.isTheaterDevice && !this.isEmergencyCupboardDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/theatre-default-config',
        'Theatre Default Config',
        'theatre-default-config',
        rolesTheatreConfiguration,
        'Theatre',
        false,
        'config',
        this.isTheaterDevice && !this.isEmergencyCupboardDevice && this.shouldAddDefaultProcedureItems
      )
    );

    this.menu.push(
      new MenuItem(
        'app/approvals',
        'Credit Approvals',
        'approvals',
        rolesApprovals,
        '',
        false,
        'done',
        !this.isOriginalTheatreDevice
      )
    );

    this.menu.push(
      new MenuItem(
        'app/my-voice-surveys',
        'Surveys',
        'Surveys',
        rolesSurveys,
        '',
        false,
        'list',
        ((this.isBackOfficeDevice || this.isTheatreBackOfficeDevice) && this.enableMyVoiceSurveys)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/stock-counting',
        'Stock Counting',
        'StockCounting',
        rolesStockCounting,
        '',
        false,
        'stack',
        this.enableStockCounting
      )
    );

    this.menu.push(
      new MenuItem(
        'app/pre-admission',
        'Pre Admission',
        'PreAdmission',
        rolesPreAdmission,
        '',
        false,
        'file-text2',
        (this.isBackOfficeDevice || this.isTheatreBackOfficeDevice)
      )
    );

    this.menu.push(
      new MenuItem(
        'app/survey-escalation-management',
        'Survey Escalation Management',
        'SurveyEscalationManagement',
        rolesUsers,
        'General Management',
        false,
        'list',
        ((this.isBackOfficeDevice || this.isTheatreBackOfficeDevice) && this.enableMyVoiceSurveys)
      )
    );
    
    this.menu.push(new MenuItem('showAbout', 'Show About', 'showAbout', [],'',
      false,
      'info'));

    this.menu.push(new MenuItem('logOut', 'Log Out', 'lognOut', [],'',
      false,
      'sign-out'));
  }

  private setupMessageChecking() {
    if (this.messageCheckInterval) 
      this.messageCheckInterval.unsubscribe();   

      this.messageCheckInterval = interval(this.messageInterval * 60000)
        .subscribe(() => {
          this.checkForNewMessages();
        });
  }

  private checkForNewMessages() {
      if (this.isCheckingMessages) 
        return; 
      
      this.isCheckingMessages = true;      
      this.messageService.messagesAvailable().subscribe(
        result => {
          this.messageCount = result;
          this.newMessage = result > 0 ? true : false;
          this.isCheckingMessages = false;
        },
        error => {
          console.error('Error checking messages:', error);
          this.isCheckingMessages = false;
        }
      );
  }

  onMessageClicked() {
    if(this.messageOpen)
      return;

    this.messageOpen = true;

      const dialogReference = this.modalService.open(
            MessagesDetailDialogComponent,
            {
              width: '80%',
              maxWidth: '1000px',
              minWidth: '600px',
              height: '80%',
              maxHeight: '800px',
              minHeight: '500px',
              disableClose: true,
            }
          );

      dialogReference.afterClosed().subscribe(() => {
        this.checkForNewMessages();
        this.messageOpen = false;
      });
  }

}